module.exports = __webpack_public_path__ + "img/pluses.ed54c200.svg";